import React, { useState } from 'react';
import { Layout, message, Table, Tag, Popconfirm, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import PageHeader from '../TopHeader/PageHeader';
import VideoListForm from '../VideoList/videoLimitSettings';
import styles from '../VideoList/VideoListStyle.module.scss';
import BillingTable from '../common/BillingTable/BillingTable';
import { use } from 'react';
const BillingCycle = () => {
  const [domainData, setDomainData] = useState(null);
  const webData = JSON.parse(localStorage.getItem('subDomainData'));
  const billingData = domainData?.billingData || webData?.billingData || [];

  return (
    <Layout className={styles.homeLayout}>
      <PageHeader title="Billing Cycle" className="all-customer-topbar" />
      <div className={styles.container}>
        <VideoListForm setDomainData={setDomainData} />
      </div>
      <div className={styles.tableDiv}>
        <BillingTable data={billingData} />
      </div>
    </Layout>
  );
};

export default BillingCycle;
